var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg119Printer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M301,392h-90c-11.046,0-20,8.954-20,20c0,11.046,8.954,20,20,20h90c11.046,0,20-8.954,20-20 C321,400.954,312.046,392,301,392z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 421,
    cy: 259,
    r: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492,312c11.046,0,20-8.954,20-20v-43c0-44.112-35.888-80-80-80h-31V20c0-11.046-8.954-20-20-20H131 c-11.046,0-20,8.954-20,20v149H80c-44.112,0-80,35.888-80,80v143c0,44.112,35.888,80,80,80h31v20c0,11.046,8.954,20,20,20h250 c11.046,0,20-8.954,20-20v-20h31c44.112,0,80-35.888,80-80c0-11.046-8.954-20-20-20c-11.046,0-20,8.954-20,20 c0,22.056-17.944,40-40,40h-31v-83h11c11.046,0,20-8.954,20-20c0-11.046-8.954-20-20-20H100c-11.046,0-20,8.954-20,20 c0,11.046,8.954,20,20,20h11v83H80c-22.056,0-40-17.944-40-40V249c0-22.056,17.944-40,40-40h352c22.056,0,40,17.944,40,40v43 C472,303.046,480.954,312,492,312z M151,349h210v123H151V349z M361,169H151V40h210V169z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg119Printer);
export default __webpack_public_path__ + "static/media/119-printer.218ff450983a2ec38532ee707353d639.svg";
export { ForwardRef as ReactComponent };